import fetch from "auth/FetchInterceptor";
import { API_BASE_URL } from "configs/AppConfig";

const BASE_URL = API_BASE_URL;

export function requestEmailList(params) {
  if (params === undefined) {
    return fetch.get(`${BASE_URL}/api/app/email-list-management`, {
      params: { limit: Number.MAX_SAFE_INTEGER },
    });
  } else {
    return fetch.get(`${BASE_URL}/api/app/email-list-management?${params}`, {
      params: { limit: Number.MAX_SAFE_INTEGER },
    });
  }
}

export function requestEmailListCreate(value) {
  console.log(value);
  const data = { ...value };
  console.log("service"+data);
  return fetch.post(
    `${BASE_URL}/api/app/email-list-management`,
    data
  );
}

export function editEmailListStatus(params) {
  const{entryInTally,id}=params;
  return fetch.put(`${BASE_URL}/api/app/email-list-management/${params._id}`, params);
}